import { CSSProperties } from 'react'

export const s = {
  wrapper: {
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '8px',
    backgroundColor: '#F0F0F0',
    overflow: 'hidden',
  } as CSSProperties,
  contentsContainer: {
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '14px',
    display: 'flex',
  } as CSSProperties,
  companyFavouriteText: {
    color: '#00366B',
    fontWeight: '600',
    lineHeight: '24px',
  } as CSSProperties,
  bookersText: {
    color: '#00366B',
    fontSize: '12px',
    lineHeight: '18px',
  } as CSSProperties,
  childrenContainer: {
    border: '2px solid #1270B8',
    boxShadow: '0px 0px 6px #1271B9',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  } as CSSProperties,
  iconContainer: {
    display: 'flex',
    alignSelf: 'center',
    paddingRight: '8px',
  } as CSSProperties,
}
